import { UserContextProps } from "@/contexts/UserContext/types";
import { Sidebar } from "@/data/types/sidebar";
import { getRemainingFreeTrialDays } from "@/services/UserService/UserService";

export const getFreeTrialDaysRemaningContent = (
  content: Sidebar,
  userContext: UserContextProps
): string => {
  const remainingFreeTrialDays = getRemainingFreeTrialDays(userContext);
  let remainingDaysContent = "";

  switch (true) {
    case remainingFreeTrialDays > 1:
      remainingDaysContent = `${remainingFreeTrialDays} ${content.sidebarFreeTrialDaysText}`; // 2 days
      break;
    case remainingFreeTrialDays === 1:
      remainingDaysContent = `${remainingFreeTrialDays} ${content.sidebarFreeTrialDayText}`; // 1 day
      break;
    default:
  }

  return `${remainingDaysContent} ${content.sidebarFreeTrialRemainingText}`;
};
